module.exports = __webpack_public_path__ + "assets/img/54f88426a0723e44e4ae7ae520551db0.svg";